exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy[data-v-f79c6344] {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nh1[data-v-f79c6344] {\n  padding: 20px;\n  text-align: center;\n}\n.privacy-content[data-v-f79c6344] {\n  width: 70%;\n}\np[data-v-f79c6344] {\n  color: #363636;\n  font-weight: 400;\n  line-height: 1.8;\n}", ""]);

// exports
